import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import ConsoleImproved from './shared/classes/ConsoleImproved';
import { listenToWindowRouteMessages } from './utils/chromeExtension/chromeExtension';

interface Props {
  children: React.ReactNode;
}

// TODO use new hook
const ListenToRouteMessageContainer = ({ children }: Props) => {
  const history = useHistory();
  const location = useLocation();
  const [newUrl, setNewUrl] = useState('');

  useEffect(() => {
    listenToWindowRouteMessages(history, setNewUrl);
  }, []);

  useEffect(() => {
    ConsoleImproved.log('New URL');
    ConsoleImproved.log(newUrl);
    ConsoleImproved.log('Current location');
    ConsoleImproved.log(location.pathname);

    if (!location.pathname.includes(newUrl)) {
      ConsoleImproved.log('Navigating to new URL');
      history.push(newUrl);
    } else {
      ConsoleImproved.log('NOT Navigating to new URL');
      ConsoleImproved.log('New URL');
      ConsoleImproved.log(newUrl);
      ConsoleImproved.log('Current location');
      ConsoleImproved.log(location.pathname);
      ConsoleImproved.log(newUrl.includes(location.pathname));
    }
  }, [newUrl]);

  return (
    <>
      {children}
    </>
  );
};

export default ListenToRouteMessageContainer;
